export const SET_PAYMENT_METHOD_DATA = 'SET_PAYMENT_METHOD_DATA';
export const SET_INVOICES_DATA = 'SET_INVOICES_DATA';
